@if (statement && emailMessage) {
    <dx-popup
        title="Statement"
        [width]="600"
        [height]="'auto'"
        [(visible)]="visible"
        [hideOnOutsideClick]="false"
        (onHiding)="onHiding($event)"
    >
        <dxi-popup-toolbar-item
            widget="dxButton"
            location="after"
            [options]="{ text: 'Print', type: 'success', onClick: print }"
            [disabled]="processing"
        ></dxi-popup-toolbar-item>
        <dxi-popup-toolbar-item
            widget="dxButton"
            location="after"
            [options]="{ text: 'Email', type: 'success', onClick: email }"
            [disabled]="processing"
        ></dxi-popup-toolbar-item>
        <dxi-popup-toolbar-item
            widget="dxButton"
            location="after"
            [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }"
            [disabled]="processing"
        ></dxi-popup-toolbar-item>
        <dx-form [formData]="statement" [colCount]="2" validationGroup="mainValidationGroup">
            <dxi-form-item dataField="startDate">
                <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
            </dxi-form-item>
            <dxi-form-item itemType="empty"></dxi-form-item>
            <dxi-form-item dataField="endDate">
                <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
            </dxi-form-item>
            <dxi-form-item itemType="empty"></dxi-form-item>
            <dxi-form-item>
                <div *dxTemplate>
                    <button class="btn btn-small btn-primary" (click)="openReport($event)">View Statement</button>
                </div>
            </dxi-form-item>
        </dx-form>
        <dx-form [formData]="emailMessage" class="mt-4" validationGroup="mainValidationGroup">
            <dxi-form-item dataField="to"> </dxi-form-item>
            <dxi-form-item dataField="cc"> </dxi-form-item>
            <dxi-form-item dataField="bcc"> </dxi-form-item>
            <dxi-form-item dataField="subject"> </dxi-form-item>
            <dxi-form-item dataField="body" editorType="dxTextArea" [editorOptions]="{ height: 350 }"> </dxi-form-item>
        </dx-form>
    </dx-popup>
}
